module.exports = __webpack_public_path__ + "img/explore_03.a676a2a9.jpg";